// extracted by mini-css-extract-plugin
export var container = "index-module--container--3lUnl";
export var logoContainer = "index-module--logoContainer--1kdrk";
export var smallAtomico = "index-module--smallAtomico--3aN10";
export var partners = "index-module--partners--2DCUb";
export var smallPartners = "index-module--smallPartners--HgvpK";
export var separator = "index-module--separator--3ePsY";